import { FC, useState, Suspense } from 'react';
import { ResetAndOutstandingDiagnosticModal } from '../../components/ResetDiagnosticModal/ResetAndOutstandingDiagnosticModal';
import { useAppSelector } from '../../redux/hooks';
import { selectedReportsFilter } from '../../redux/reducers/filterReportsSlice';
import { Diagnostic } from '../../models/Student';
import { Student } from '../../models/Student';
import { QueryAllStudents } from './QueryAllStudents';
import { PageInfo } from '../../models/PageInfo';

export interface StudentsData extends Student {
  diagnostics: Diagnostic[];
}

export interface DiagnosticModalTableFilters {
  first: number;
  rows: number;
  page?: number;
  pageCount: number;
  sortField: string;
  sortOrder: 1 | -1;
  filters: Filters;
  multiSortMeta: null;
  prevPage: number;
}
interface Filters {
  name: string;
  completedOn: (Date | null)[] | null;
  classes: string[];
  site: { id: string; name: string }[] | null;
  grade: { id: string; name: string }[] | null;
  [key: string]: string | number | string[] | number[] | (Date | null)[] | { id: string; name: string }[] | null;
}

export const filterStateDiagnosticOutstandingInitValue: DiagnosticModalTableFilters = {
  first: 0,
  rows: 5,
  page: 0,
  pageCount: 0,
  sortField: 'name',
  sortOrder: 1,
  filters: {
    name: '',
    classes: [],
    grade: null,
    site: null,
    completedOn: null,
  },
  multiSortMeta: null,
  prevPage: 0,
};

interface Props {
  header: string;
  visible: boolean;
  isReset: boolean;
  setVisible: () => void;
}

const ResetAndOutstandingDiagnosticModalWrapper: FC<Props> = ({ header, visible, isReset, setVisible }: Props) => {
  const [studentsInfo, setStudentsInfo] = useState<StudentsData[]>([]);
  const reportsFilterRedux = useAppSelector(selectedReportsFilter);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const [fetchingData, setFetchingData] = useState<boolean>(true);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageInfo, setPageInfo] = useState<PageInfo | undefined>(undefined);
  const [submitFetchKey, setSubmitFetchKey] = useState(0);
  const [filterState, setFilterState] = useState({
    ...filterStateDiagnosticOutstandingInitValue,
    filters: {
      ...filterStateDiagnosticOutstandingInitValue.filters,
      classes: reportsFilterRedux.classes.map(cl => cl.id),
    },
  });

  return (
    <div>
      <ResetAndOutstandingDiagnosticModal
        isReset={isReset}
        header={header}
        studentsInfo={studentsInfo}
        visible={visible}
        totalRecords={totalRecords}
        setVisible={() => setVisible()}
        setFilterState={setFilterState}
        filterState={filterState}
        fetchingData={fetchingData}
        setFetchingData={setFetchingData}
        setSubmitFetchKey={setSubmitFetchKey}
      />
      <Suspense>
        <QueryAllStudents
          submitFetchKey={submitFetchKey}
          isReset={isReset}
          setStudents={setStudentsInfo}
          filterState={filterState}
          setTotalRecords={setTotalRecords}
          pageInfo={pageInfo}
          setPageInfo={setPageInfo}
          setFetchingData={setFetchingData}
          fetchingData={fetchingData}
          setFirstLoad={setFirstLoad}
          firstLoad={firstLoad}
        />
      </Suspense>
    </div>
  );
};

export default ResetAndOutstandingDiagnosticModalWrapper;
